// extracted by mini-css-extract-plugin
export var textInput = "_jd-0";